/* eslint-disable react/no-danger */
import React from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Control, Fieldset } from 'react-redux-form';
import { InlineTip } from '../../../components/Tooltip';

import {
  externalOfferOrderAmountPath,
  externalOfferOrderDeliveryPath,
  externalOfferOrderTransferPath,
} from '../../Forms/Schemas/baseRrf';
import BaseDetailScreen from '../../BaseDetailScreen';
import Button from '../../Button';
import './styles.css';

// should show payment information
const Component = ({
  offer,
  onNext,
  deliveryInformation,
}) => {
  const back = {
    label: 'Review Offering Documents',
    to: `/external-invest/${offer.id}/disclosures`,
  };
  const radioStyle = {
    marginRight: '10px',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    display: 'inline-block',
    backgroundColor: 'transparent',
    border: 'none',
    outline: 'none',
    width: '20px',
    height: '20px',
    top: '4px',
    position: 'relative',
  };

  return (
    <BaseDetailScreen
      backLabel={back.label}
      backTo={back.to}
      pageHeading="Funding & Security Delivery Info"
      pageSubheading=""
    >
      <div styleName="bankInfo">
        <div styleName="head">Wiring Instruction</div>
        <div styleName="table">
          <table style={{ width: '100%' }}>
            <tbody>
              <tr styleName="spaceUnder">
                <td>Bank Name:</td>
                <td><span dangerouslySetInnerHTML={{ __html: offer.wiringInstrBankName }} /></td>
              </tr>
              <tr styleName="spaceUnder">
                <td>ABA #:</td>
                <td><span dangerouslySetInnerHTML={{ __html: offer.wiringInstrABANumber }} /></td>
              </tr>
              <tr styleName="spaceUnder">
                <td>A/C #:</td>
                <td><span dangerouslySetInnerHTML={{ __html: offer.wiringInstrAccountNumber }} /></td>
              </tr>
              <tr styleName="spaceUnder">
                <td>A/C Name:</td>
                <td><span dangerouslySetInnerHTML={{ __html: offer.wiringInstrAccountName }} /></td>
              </tr>
              <tr styleName="spaceUnder">
                <td>Attn:</td>
                <td><span dangerouslySetInnerHTML={{ __html: offer.wiringInstrAttentionLine }} /></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div styleName="optionsInfo" style={{ maxWidth: 466 }}>
        <div styleName="deliveryTitle">
          <span>
            Security Delivery Information
          </span>
        </div>
        <Fieldset model={`${externalOfferOrderDeliveryPath}.delivery`}>
          {!_.isEmpty(offer.securityDeliveryInformationOptions) &&
            !_.isEmpty(offer.securityDeliveryInformationOptions.options) &&
            offer.securityDeliveryInformationOptions.options.map((option) => {
              if (_.isEmpty(offer.securityDeliveryInformationOptions.rootType)) {
                return null;
              }
              const {
                optionLabel,
                optionTooltip,
                initialValue,
                isReadOnly,
              } = option;
              const tooltipStartIndices = [...optionLabel.matchAll(new RegExp('<tooltip>', 'gi'))].map(a => a.index);
              const tooltipStartIndex = tooltipStartIndices.length > 0 ? tooltipStartIndices[0] : -1;
              const tooltipEndIndices = [...optionLabel.matchAll(new RegExp('</tooltip>', 'gi'))].map(a => a.index);
              const tooltipEndIndex = tooltipEndIndices.length > 0 ? tooltipEndIndices[0] : -1;
              const arrayOfRendering = [];
              let lastIndex = 0;
              if (tooltipStartIndex < tooltipEndIndex && tooltipStartIndex >= 0 && tooltipStartIndex >= 0) {
                // eslint-disable-next-line no-constant-condition
                while (true) {
                  const substringedText = optionLabel.substring(lastIndex);
                  if (lastIndex < tooltipStartIndex) {
                    arrayOfRendering.push(<span>{substringedText.substring(0, tooltipStartIndex)}</span>);
                    lastIndex = tooltipStartIndex + '<tooltip>'.length;
                  } else if (lastIndex === tooltipStartIndex + '<tooltip>'.length) {
                    const tooltipLabel = substringedText.substring(0, tooltipEndIndex - lastIndex);
                    arrayOfRendering.push(<InlineTip styleType text={optionTooltip}>{tooltipLabel}</InlineTip>);
                    lastIndex = tooltipEndIndex + '</tooltip>'.length;
                  } else {
                    arrayOfRendering.push(<span>{substringedText}</span>);
                    break;
                  }
                }
              } else {
                arrayOfRendering.push(optionLabel);
              }

              const radioId = _.snakeCase(optionLabel);
              const radioValue = optionLabel.replace('<tooltip>', '').replace('</tooltip>', '');
              const isActive = _.isEmpty(deliveryInformation.delivery) ? initialValue : radioValue === deliveryInformation.delivery;
              switch (offer.securityDeliveryInformationOptions.rootType) {
                case 'radio_list':
                  return (
                    <div styleName="externalInvestDeliveryOption" >
                      <Control.radio
                        key={`${externalOfferOrderDeliveryPath}.delivery`}
                        model={`${externalOfferOrderDeliveryPath}.delivery`}
                        id={radioId}
                        value={radioValue}
                        styleName={`externalInvestDeliveryOptionRadio${isActive ? 'Active' : ''}`}
                        style={{ ...radioStyle, marginRight: '15px' }}
                        isReadOnly={isReadOnly}
                      />
                      <label styleName="externalInvestDeliveryOptionLabel" htmlFor={radioId}>
                        <div>{arrayOfRendering}</div>
                      </label>
                    </div>
                          );
                default:
              }
              return null;
            })}
        </Fieldset>
        <div styleName="infoTextDelivery">
          {offer.securityDeliveryInformationOptions.disclaimer}
        </div>
        <div styleName="submitButtonContainer">
          <Button onClick={onNext}>
            Continue
          </Button>
        </div>
      </div>
    </BaseDetailScreen>
  );
};

Component.displayName = 'SecurityDeliveryInformation';

Component.defaultProps = {
  investment: {
    totalInvestment: 0.00,
  },
};

const mapStateToProps = state => ({
  bankLinks: get(state, `accountBankLinks.[${state.currentAccount}].data`, []),
  user: state.user.data,
  deliveryInformation: get(state, externalOfferOrderDeliveryPath),
  offerOrderAmount: get(state, externalOfferOrderAmountPath),
  offerOrderTransferFunds: get(state, externalOfferOrderTransferPath),
});

export default connect(mapStateToProps)(Component);



// WEBPACK FOOTER //
// ./src/components/ExternalInvest/InvestmentViews/SecurityDeliveryInformation.js